import React from "react";
import Header from "../menu/Header";
import Footer from "../Homepage/Footer";

export default function Articles() {
  return (
    <div className="h-screen ">
      <Header />
      <p className="h-56 flex justify-center items-center text-2xl">
        Coming soon...
      </p>
      <Footer />
    </div>
  );
}
